import React from 'react';

const Ster = () => (
	<svg viewBox="0 0 100 100" className="af-icon">
		<path className="ster" d="M70.8,80L50,66.5L29.2,80l7.9-24.3L16.5,38.8H42l8-22.5l8,22.5h25.5L62.9,55.7L70.8,80z M50,63.5l16.3,10.6 L60,54.8l16.5-13.6H56.2L50,23.7l-6.2,17.5H23.5L40,54.8l-6.3,19.2L50,63.5z"/>
	</svg>
);

export default Ster;



